export default "__VITE_ASSET__DCwEJsyS__"